// src/components/Footer.js
import React from 'react';
import { Link } from 'react-router-dom';
import { FileText, Shield, FileCheck } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-gray-100 border-t">
      {/* תוכן ראשי של הפוטר */}
      <div className="container mx-auto px-4 py-8">
        <div className="grid md:grid-cols-3 gap-8">
          {/* לינקים חשובים */}
          <div>
            <h3 className="text-lg font-bold text-gray-700 mb-4">מידע חשוב</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/privacy" className="text-gray-600 hover:text-blue-600 flex items-center gap-2">
                  <Shield className="w-4 h-4" />
                  מדיניות פרטיות
                </Link>
              </li>
              <li>
                <Link to="/accessibility" className="text-gray-600 hover:text-blue-600 flex items-center gap-2">
                  <FileCheck className="w-4 h-4" />
                  הצהרת נגישות
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-gray-600 hover:text-blue-600 flex items-center gap-2">
                  <FileText className="w-4 h-4" />
                  תנאי שימוש
                </Link>
              </li>
            </ul>
          </div>

          {/* הצהרת אחריות */}
          <div>
            <h3 className="text-lg font-bold text-gray-700 mb-4">הצהרה משפטית</h3>
            <p className="text-sm text-gray-600">
              התוכן באתר זה נועד לספק מידע כללי בלבד ואינו מהווה ייעוץ משפטי, 
              חוות דעת מקצועית או תחליף לייעוץ אישי מול עורך דין.
            </p>
          </div>

          {/* אבטחת מידע */}
          <div>
            <h3 className="text-lg font-bold text-gray-700 mb-4">אבטחת מידע</h3>
            <p className="text-sm text-gray-600">
              האתר עושה שימוש בטכנולוגיות אבטחה מתקדמות, כולל תעודת SSL, 
              כדי להצפין את המידע המועבר ולהבטיח את פרטיותכם.
            </p>
          </div>
        </div>
      </div>

      {/* קרדיט ויוצרים */}
      <div className="border-t">
        <div className="container mx-auto px-4 py-4">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-sm text-gray-600">
            <div>
              © {new Date().getFullYear()} כל הזכויות שמורות למיכלסון ושות
            </div>
            <div className="flex items-center gap-2">
              <span>אתר זה פותח ע"י</span>
              <a
                href="https://mh-sitedev.com"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 hover:text-blue-800 font-medium"
              >
                MH Site Development
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;